import React from 'react';

import { useErrorContext } from '../components/error';
import { ErrorBanner, ErrorDialog } from '../components/error';

// ----------------------------------------------------------

interface BaseLayoutProps {
  children: React.ReactNode;
}

// ----------------------------------------------------------

const BaseLayout: React.FC<BaseLayoutProps> = ({ children }) => {
  const { error, setError, bannerError, setBannerError } = useErrorContext();

  return (
    <main className="appWrapper">
      <ErrorDialog
        isOpen={!!error}
        onClose={() => setError(null)}
        errorMessage={error?.message}
        userFacingMessage={error?.userFacingMessage}
      />
      {children}
      <ErrorBanner
        open={!!bannerError}
        onClose={() => setBannerError(null)}
        error={{
          status: bannerError?.status ?? 'Error',
          message: bannerError?.message ?? 'An error occurred',
          estimatedFixTime: bannerError?.estimatedFixTime ?? null,
        }}
      />
    </main>
  );
};

export default BaseLayout;
